import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';
import type { AccessControlConfigResponse } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class AccessControlService {
  private http = inject(HttpClient);

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  /**
   * Get Tenant Access Control Configuration
   * GET /tenants/{tenant_id}/access_control_config
   */
  getTenantAccessControlConfig(tenantId: number): Observable<AccessControlConfigResponse[]> {
    return this.http
      .get<AccessControlConfigResponse[]>(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ACCESS_CONTROL.GET_TENANT_CONFIG
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: AccessControlConfigResponse[]) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
